export const sliderData = [
    {image: "slide1"},
    {image: "slide2"},
    {image: "slide3"}
]